// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"g4-z","dimensionLabel":"h4-z","styleChooserControlWrapper":"i4-z","styleChooserControl":"j4-z","disabled":"k4-z","giftCard":"l4-z","styleChooserText":"m4-z"};